const SmoothScroll = {
  init () {

    if ( $('.smooth-scroll').length ) {
      // Scroll to section
      $('.smooth-scroll').click(function () {
        if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {

          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

          if (target.length) {
            $('html,body').animate({
            // the 0 is a fixed header offset
              scrollTop: target.offset().top - 0
            }, 500);
            return false;
          }
        }
      });
    }
  }
};

export default SmoothScroll;
